import { Breadcrumb, PageHeader } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { useHistory } from "react-router-dom";

import { Routes } from "../../../Utils/Constants/routes";
import { RootContext } from "../../Root";
import "./index.css";

interface CommonLayoutProps {
  // Kept for backward compatibility.
  imageUrl?: any;

  children: React.ReactNode;
  title?: any;

  // Back button is shown only when explicitly enabled.
  showBackButton?: boolean;
}

const CommonLayout: React.FC<CommonLayoutProps> = ({
  children,
  title,
  showBackButton = false,
}) => {
  const history = useHistory();
  const { location } = useHistory();
  const { setHeader }: any = useContext(RootContext);

  const getTypeOfRoute: any = useMemo(() => {
    return {
      [Routes.termsandconditions]: "Terms & Conditions",
      [Routes.deleteAccount]: "Delete Account",
      [Routes.reportIssue]: "Report Issues",
      [Routes.userprofile]: "User Profile",
      [Routes.history]: "History",
      [Routes.changePassword]: "Reset PIN",
      [Routes.privacyandpolicy]: "Privacy & Policy",
      [Routes.grievanceredressal]: "Grievance Redressal",
    };
  }, []);

  const goBack2 = useCallback(() => {
    history.goBack();
  }, [history]);

  useEffect(() => {
    setHeader(
      <Breadcrumb className="breadCrumbs" separator=">">
        <Breadcrumb.Item onClick={goBack2}>
          More
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          {getTypeOfRoute["/" + location.pathname.split("/")[2]]}
        </Breadcrumb.Item>
      </Breadcrumb>
    );

    return () => {
      setHeader(null);
    };
  }, [
    goBack2,
    setHeader,
    getTypeOfRoute,
    location.pathname,
  ]);

  return (
    <div className="commonLayoutRoot">
      {showBackButton && (
        <div className="commonLayoutHeader">
          <PageHeader
            className="commonLayoutPageHeader"
            backIcon={
              <ArrowLeftOutlined
                className="commonLayoutBackIcon"
                onPointerOverCapture={undefined}
                onPointerMoveCapture={undefined}
              />
            }
            onBack={goBack2}
            title={title}
          />
        </div>
      )}

      <div className="commonLayoutContent">
        {children}
      </div>
    </div>
  );
};

export default CommonLayout;